import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=3aae7bbb&scoped=true&"
import script from "./ReviewDetail.vue?vue&type=script&lang=js&"
export * from "./ReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=3aae7bbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae7bbb",
  null
  
)

export default component.exports